import type { ImmunisationData } from "@qendo/medical/immunisation";
import { MedicalType } from "@qendo/medical/types";
import type { DateArg } from "date-fns";
import Data from "~/util/data";

export class Immunisation extends Data implements ImmunisationData {
    public readonly type = MedicalType.immunisation;

    constructor(
        public id?: string,
        public description: string | null = null,
        public option_id: string | null = null,
        public photograph_ids: string[] = [],
        public immunisation_date: string | DateArg<Date> | null = null,
    ) {
        super();
    }
}
